import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface UserSlice {
  email: string;
  firstName: string;
  lastName: string;
  planName: string;
  planId: string;
  loggedIn: boolean;
  initialized: boolean;
}

const initialState: UserSlice = {
  email: "",
  firstName: "",
  lastName: "",
  planName: "",
  planId: "",
  loggedIn: false,
  initialized: false,
};

const userSlice = createSlice({
  name: "userSlice",
  initialState,
  reducers: {
    initializeUserSlice: (state, action: PayloadAction<UserSlice>) => {
      state = action.payload;
    },
    resetUserSlice: (state) => {
      state = {
        ...initialState,
        initialized: true,
      };
    },
  },
});

export const { initializeUserSlice, resetUserSlice } = userSlice.actions;

export const userReducer = userSlice.reducer;
